/**
 * @generated SignedSource<<452319dbbb0b26f9dbccf1f08ab8bf32>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type useBJFMiningClaimMutation$variables = {};
export type useBJFMiningClaimMutation$data = {
  readonly claimMinedBjf: {
    readonly minedAmount: number;
  } | null;
};
export type useBJFMiningClaimMutation = {
  variables: useBJFMiningClaimMutation$variables;
  response: useBJFMiningClaimMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ClaimMinedBjfPayload",
    "kind": "LinkedField",
    "name": "claimMinedBjf",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "minedAmount",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useBJFMiningClaimMutation",
    "selections": (v0/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useBJFMiningClaimMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "c032d6d9190f497d0e10322f2b5516e9",
    "id": null,
    "metadata": {},
    "name": "useBJFMiningClaimMutation",
    "operationKind": "mutation",
    "text": "mutation useBJFMiningClaimMutation {\n  claimMinedBjf {\n    minedAmount\n  }\n}\n"
  }
};
})();

(node as any).hash = "78d45e980f49d3a322be1af8085544ac";

export default node;
